import { Component, DestroyRef, inject, signal } from '@angular/core';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { AuthService } from 'core/services/auth.service';
import { UsersService } from 'core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, switchMap } from 'rxjs';
import { KorviuLoaderComponent } from 'shared/components/korviu-loader/korviu-loader.component';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-remove-account-modal',
  standalone: true,
  imports: [KorviuButtonComponent, NzIconDirective, TranslateModule, NzModalModule, KorviuLoaderComponent],
  templateUrl: './remove-account-modal.component.html',
  styleUrl: './remove-account-modal.component.scss'
})
export class RemoveAccountModalComponent {
  public isLoading = signal<boolean>(false);
  private _modal = inject(NzModalRef);
  private _authService = inject(AuthService);
  private _usersService = inject(UsersService);
  private _destroyRef = inject(DestroyRef);

  public onBackClick(): void {
    this._modal.destroy(false);
  }

  public onRemoveClick(): void {
    this._removeAccount();
  }

  private _removeAccount(): void {
    this.isLoading.set(true);
    this._usersService
      .removeOkeeyCashAccount()
      .pipe(
        tap(() => {
          this._modal.destroy(true);
        }),
        finalize(() => {
          this.isLoading.set(false);
        }),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe();
  }
}
